//import { Path } from '../routes'
import * as types from '../constants/Action_types'

const initialState = {
    feedback: [],

}

export default function (state = initialState, action) {

    switch (action.type) {

        case types.GET_FEEDBACK:
            return {
                ...state,
                feedback: action.payload
            }
        default:
            return state
    }
}
